<template>
  <v-container>
    <v-row
      v-if="!Loading"
      justify="center">
      <v-col
        offset-xl
        md="10">
        <v-card>
          <v-toolbar
            color="primary"
            dark>
            <v-toolbar-title>
              <v-icon>speaker_notes</v-icon>メッセージを見る/送る
            </v-toolbar-title>
          </v-toolbar>
          <v-container>
            <span>リクエスト承認済の生徒の父兄の方とメッセージのやり取りができます。</span>
          </v-container>
        <v-divider></v-divider>
        <div
          v-if="this.parents.length === 0">
          <v-card-text class="text--primary">
            現在メッセージを送れる相手がいません。
          </v-card-text>
        </div>
        <div
          v-else
          v-for="(parent, index) in this.parents"
          :key="index"
          style="cursor:pointer"
          @click="open(parent)"
        >
          <v-container fluid>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <span
                    class="font-weight-bold subheading">
                    {{ parent.fullName() }} さん
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-container>
        </div>
        </v-card>
        <MessageFromParent
          v-if="selectedParent"
          :parent="selectedParent"
          :isOpen="window"
          @open="open"
          @close="close"
        />
      </v-col>
    </v-row>
    <v-row
      v-else>
      <Loading/>
    </v-row>
  </v-container>
</template>

<script>

import { ParentRepository } from "@/repository/ParentRepository.js"
import { StudentRepository } from "@/repository/StudentRepository.js"
import { firestore } from "@/repository/client/firestore.js"
import Loading from "@/components/organisms/Loading.vue"
import MessageFromParent from "@/components/organisms/teacher/MessageFromParent.vue"

export default {
  name: "TeacherMessage",
  components: {
    'Loading': Loading,
    MessageFromParent: MessageFromParent,
  },
  data () {
    return {
      teacher: this.$store.getters.teacher,
      selectedParent: null,
      parents: [],
      window: false,
      Loading: true,
    }
  },
  methods: {
    async open(parent) {
      await this.close()
      this.selectedParent = parent
      this.window = true
    },
    close() {
      this.window = false
      this.selectedParent = null
    }
  },
  created: async function() {
    const studentRepo = new StudentRepository(firestore)
    const parentRepo = new ParentRepository(firestore)
    const students = await studentRepo.collect(this.teacher.studentIds)
    const parentIds = students.filterParentId()
    this.parents = await parentRepo.collect(parentIds)
    this.Loading = false
  }
}
</script>

